// THIS FILE IS GENERATED. ANY CHANGES TO THIS FILE WILL BE LOST.
import type { TOC } from '@ember/component/template-only';

export interface ExpandHorizontalIconSignature {
  Element: SVGSVGElement;
}

export const ExpandHorizontalIcon: TOC<ExpandHorizontalIconSignature> = <template><svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" ...attributes>
<path d="M17.707 7.29303L16.293 8.70703L18.586 11H5.414L7.707 8.70703L6.293 7.29303L1.586 12L6.293 16.707L7.707 15.293L5.414 13H18.586L16.293 15.293L17.707 16.707L22.414 12L17.707 7.29303Z"/>
</svg>
</template>;